let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("1dYfC")).then(() => parcelRequire('jlooF'));